import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { mask } from 'vue-the-mask'

import moment from 'moment'
import HandleDateMixin from '@/mixin/handleDate'

export default {
  props: [
    'isDialogEditPeriodOpen'
  ],
  directives: {
    mask
  },
  mixins: [HandleDateMixin],
  data () {
    return {
      isSaveButtonLoading: false,
      isOpenDate: false,
      periodInitialDate: '',
      periodFinalDate: '',
      period: {
        id: null,
        idaccount: null,
        idaccounttype: null,
        startperiod: '',
        endperiod: '',
        licenses: null,
        active: true,
        codcontract: ''
      },
      itemsSelectStatus: [
        {
          text: 'Ativado',
          value: true
        },
        {
          text: 'Desativado',
          value: false
        }
      ]
    }
  },
  mounted () {
    this.period = this.getterSelectedPeriod
    this.periodInitialDate = this.getterSelectedPeriod.startperiod !== '' ? moment(this.getterSelectedPeriod.startperiod).format('DD/MM/YYYY') : ''
    this.periodFinalDate = this.getterSelectedPeriod.endperiod !== '' ? moment(this.getterSelectedPeriod.endperiod).format('DD/MM/YYYY') : ''
  },
  computed: {
    ...mapGetters([
      'getterSelectedMaintainer',
      'getterRegistrationTypes',
      'getterSelectedPeriod'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_PERIOD',
      'CLEAR_SELECTED_PERIOD'
    ]),
    ...mapActions([
      'actionAddMaintainerPeriod',
      'actionEditMaintainerPeriod'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    closeEditPeriodDialog () {
      this.CLEAR_SELECTED_PERIOD()
      this.periodInitialDate = ''
      this.periodFinalDate = ''

      this.$emit('emit-close-period-edit-dialog')
    },
    editPeriod () {
      const [initialDay, initialMonth, initialYear] = this.separateDateElements(this.periodInitialDate)
      const [finalDay, finalMonth, finalYear] = this.separateDateElements(this.periodFinalDate)

      if (
        parseInt(finalDay) > 31 ||
        parseInt(initialDay) > 31 ||
        parseInt(finalMonth) > 12 ||
        parseInt(initialMonth) > 12
      ) {
        this.addToast({
          text: 'Data informada inválida.',
          type: 'danger'
        })
      } else {
        this.isSaveButtonLoading = true

        this.period.startperiod = moment(new Date(initialYear, (initialMonth - 1), initialDay)).format('YYYY-MM-DD')
        this.period.endperiod = moment(new Date(finalYear, (finalMonth - 1), finalDay)).format('YYYY-MM-DD')

        this.SET_SELECTED_PERIOD(this.period)

        const params = {
          maintainerId: this.getterSelectedMaintainer.id,
          period: {
            id: this.getterSelectedPeriod.id,
            idAccount: this.period.idaccount,
            idAccountType: this.period.idaccounttype,
            startPeriod: this.period.startperiod,
            endPeriod: this.period.endperiod,
            licenses: this.period.licenses,
            active: this.period.active,
            codContract: this.period.codcontract
          }
        }

        this.actionEditMaintainerPeriod(params)
          .then(() => {
            this.addToast({
              text: 'Período atualizado com sucesso.',
              type: 'success'
            })

            this.isSaveButtonLoading = false
            this.closeEditPeriodDialog()
          })
          .catch((e) => {
            this.addToast({
              text: e.message || e,
              type: 'danger'
            })

            this.isSaveButtonLoading = false
          })
      }
    },
    createNewPeriod () {
      const [initialDay, initialMonth, initialYear] = this.separateDateElements(this.periodInitialDate)
      const [finalDay, finalMonth, finalYear] = this.separateDateElements(this.periodFinalDate)

      if (
        parseInt(finalDay) > 31 ||
        parseInt(initialDay) > 31 ||
        parseInt(finalMonth) > 12 ||
        parseInt(initialMonth) > 12
      ) {
        this.addToast({
          text: 'Data informada inválida.',
          type: 'danger'
        })
      } else {
        this.isSaveButtonLoading = true

        this.period.startperiod = moment(new Date(initialYear, (initialMonth - 1), initialDay)).format('YYYY-MM-DD')
        this.period.endperiod = moment(new Date(finalYear, (finalMonth - 1), finalDay)).format('YYYY-MM-DD')

        const params = {
          maintainerId: this.getterSelectedMaintainer.id,
          period: {
            idAccount: this.getterSelectedMaintainer.id,
            idAccountType: this.period.idaccounttype,
            startPeriod: this.period.startperiod,
            endPeriod: this.period.endperiod,
            licenses: this.period.licenses,
            active: this.period.active,
            codContract: this.period.codcontract
          }
        }

        this.actionAddMaintainerPeriod(params)
          .then(() => {
            this.addToast({
              text: 'Período adicionado com sucesso.',
              type: 'success'
            })

            this.isSaveButtonLoading = false
            this.closeEditPeriodDialog()
          })
          .catch((e) => {
            this.addToast({
              text: e.message || e,
              type: 'danger'
            })

            this.isSaveButtonLoading = false
          })
      }
    }
  }
}
